// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__14rR2","addWidgetButton":"Header_addWidgetButton__1FOyK","dashboardTabs":"Header_dashboardTabs__28xjH","active":"Header_active__1r0-_"};